import { addIcon, type IconifyJSON } from "@iconify/react/offline";
import lucideIcons from "@iconify-json/lucide/icons.json";
import lucideLabIcons from "@iconify-json/lucide-lab/icons.json";

const registerIcon = (collection: IconifyJSON, iconName: string): string => {
	const registeredName = `${collection.prefix}:${iconName}`;
	const iconData = collection.icons[iconName];

	if (!iconData) {
		throw new Error(`Icon "${registeredName}" is missing from the "${collection.prefix}" collection.`);
	}

	addIcon(registeredName, {
		...iconData,
		width: iconData.width ?? collection.width,
		height: iconData.height ?? collection.height,
	});

	return registeredName;
};

const ICON_MAP = {
	// General
	// Named after the action, not the shape — both are chevrons pointing the way the panel will move.
	collapse: registerIcon(lucideIcons, "chevron-up"),
	uncollapse: registerIcon(lucideIcons, "chevron-down"),
	drag: registerIcon(lucideIcons, "grip-vertical"),
	close: registerIcon(lucideIcons, "x"),
	valid: registerIcon(lucideIcons, "circle-check-big"),
	invalid: registerIcon(lucideIcons, "circle-x"),
	checkbox: registerIcon(lucideIcons, "square"),
	checkboxChecked: registerIcon(lucideIcons, "square-check-big"),
	bookmark: registerIcon(lucideIcons, "bookmark"),
	settings: registerIcon(lucideIcons, "settings"),
	panelDocked: registerIcon(lucideIcons, "panel-right"),
	panelTooltip: registerIcon(lucideIcons, "square-mouse-pointer"),
	star: registerIcon(lucideIcons, "star"),
	search: registerIcon(lucideIcons, "search"),
	arrowUp: registerIcon(lucideIcons, "arrow-up"),
	arrowDown: registerIcon(lucideIcons, "arrow-down"),
	chevronUp: registerIcon(lucideIcons, "chevron-up"),
	chevronDown: registerIcon(lucideIcons, "chevron-down"),
	filter: registerIcon(lucideIcons, "filter"),
	results: registerIcon(lucideIcons, "layout-list"),
	// View controls
	camera: registerIcon(lucideIcons, "camera"),
	zoomIn: registerIcon(lucideIcons, "plus"),
	zoomOut: registerIcon(lucideIcons, "minus"),
	reset: registerIcon(lucideIcons, "rotate-ccw"),
	locate: registerIcon(lucideIcons, "crosshair"),
	// The needle is rotated to match the map bearing, so it must point straight up at bearing 0.
	compass: registerIcon(lucideIcons, "navigation-2"),
	projection: registerIcon(lucideIcons, "box"),
	// Tools
	select: registerIcon(lucideIcons, "mouse-pointer"),
	polyline: registerIcon(lucideIcons, "spline"),
	circle: registerIcon(lucideIcons, "circle"),
	polygon: registerIcon(lucideIcons, "triangle-right"),
	footprint: registerIcon(lucideLabIcons, "triangle-stripes"),
	// Appearance
	ghost: registerIcon(lucideIcons, "ghost"),
	showAll: registerIcon(lucideIcons, "eye"),
} as const;

export { ICON_MAP };
